import React from 'react';
import Header from '../../_components/header/header';
import Footer from '../../_components/footer/footer';
import { Col, Row, Container } from 'reactstrap';
import PersonalDetailsCard from '../../_components/cards/PersonalDetailsCard';
import PersonalFormCard from '../../_components/cards/PersonalFormCard';
import LeftMenu from '../../_components/cards/LeftMenu';
class PersonalDetails extends React.Component {
    render() {
        return (
            <>
                <Header />
                <Container fluid={true}>
                    <section className="dashboard-page">
                        <h2 className="dashboard-heading">My Profile</h2>
                        <Row>
                            <Col md={{ size: "9" }}>
                                <PersonalDetailsCard />
                                <PersonalFormCard />
                            </Col>
                            <Col md={{ size: "3" }}>
                                <LeftMenu />
                            </Col>
                        </Row>
                    </section>
                </Container>
                <Footer />
            </>
        )
    }
}
export default PersonalDetails